module.exports = __webpack_public_path__ + "static/assets/ac659b604572e2ae739cba3da0d67871.svg";